var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",staticStyle:{"padding-top":"10px"}},[_c('b-button',{attrs:{"size":"sm","variant":"outline-danger"},on:{"click":_vm.delete_shop}},[_c('b-icon-trash'),_vm._v(" elimina la Parola Chiave")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }